import * as Types from "../../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FetchBankFactsheetsQueryVariables = Types.Exact<{
  bank_id: Types.Scalars["Int"];
}>;

export type FetchBankFactsheetsQuery = { __typename?: "query_root" } & {
  banks_by_pk?: Types.Maybe<
    { __typename?: "banks" } & {
      bank_factsheets: Array<
        { __typename?: "bank_factsheets" } & Pick<
          Types.Bank_Factsheets,
          "factsheetDate"
        > & {
            upload: { __typename?: "uploads" } & Pick<
              Types.Uploads,
              "reviewed" | "description" | "created_at" | "public_url" | "id"
            >;
          }
      >;
    }
  >;
};

export const FetchBankFactsheetsDocument = gql`
  query FetchBankFactsheets($bank_id: Int!) {
    banks_by_pk(id: $bank_id) {
      bank_factsheets {
        factsheetDate
        upload {
          reviewed
          description
          created_at
          public_url
          id
        }
      }
    }
  }
`;

export function useFetchBankFactsheetsQuery(
  options: Omit<
    Urql.UseQueryArgs<FetchBankFactsheetsQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<FetchBankFactsheetsQuery>({
    query: FetchBankFactsheetsDocument,
    ...options,
  });
}
